/// @flow
import classnames from 'classnames';
import React from 'react';

import CloseButton from '../../../components/CCMode/CloseButton';
import ExpandButton from '../../../components/CCMode/ExpandButton';
import StartConversationButton from '../../../components/CCMode/StartConversationButton';

import type { CCMode } from '../../../types/cc-mode';

import useStyles from './HomeView.styles';

interface Props {
  createNewConversation: () => void;
  setCCMode: (ccMode: CCMode) => void;
  setShowBubbleAboveCCMode: (shouldShow: boolean) => void;
  showBubbleAboveCCMode: boolean;
  updateElectronCaptionMode: (isElectronCaptionMode: boolean) => void;
}

const HomeView = ({
  createNewConversation,
  setCCMode,
  setShowBubbleAboveCCMode,
  showBubbleAboveCCMode,
  updateElectronCaptionMode,
}: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div
        className={classnames(classes.buttons, {
          [classes.buttonsVisible]: showBubbleAboveCCMode,
        })}
      >
        <ExpandButton onClick={() => updateElectronCaptionMode(false)} />
        <CloseButton onClick={() => window.electronIPC.sendCCMode('close')} />
      </div>
      <StartConversationButton
        onClick={() => {
          setCCMode('conversation');
          createNewConversation();
        }}
        onMouseEnter={() => setShowBubbleAboveCCMode(true)}
      />
    </div>
  );
};

export default HomeView;
